import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";
import { colors } from "../constants/GlobalStyles";

const IconDots = (props: IconProps) => (
  <svg
    width={props.width ? props.width : 24}
    height={props.height ? props.height : 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="6" cy="12" r="2" fill={props.color || colors.secondaryAction.default} />
    <circle cx="12" cy="12" r="2" fill={props.color || colors.secondaryAction.default} />
    <circle cx="18" cy="12" r="2" fill={props.color || colors.secondaryAction.default} />
  </svg>
);

export default IconDots;
